export const customerModels = [
  {
    name: 'customer',
    fields: [
      'firstName',
      'lastName',
      'email',
      'studentId',
      'phone',
      'mobile',
      'address',
      'city',
      'state',
      'zip',
      'password',
    ],
    relationships: {
      shoppingCarts: { type: 'shoppingCart', relationship: 'hasMany' },
    },
  },
]
